import { api } from "@/lib/api";
import { toast } from "sonner";

const TYPE_MAP = {
  music: "music_news", entertainment: "entertainment_news", local: "local_news",
  sports: "sports_news", weather: "weather", traffic: "traffic",
  breaking: "breaking_news", headlines: "headline_news", top_of_hour: "top_of_hour",
};

export async function produceInNewsStudio(navigate, { script, category = "headlines", title = "" }) {
  if (!script?.trim()) { toast.error("No script to produce yet"); return; }
  try {
    const { data } = await api.post("/news-studio/bulletins", {
      bulletin_type: TYPE_MAP[category] || "headline_news",
      duration_key: "radio_30", raw_script: script, title,
      voice_id: "female_news", branding: {},
    });
    toast.success("Script handed to News Studio — full production booth ready");
    navigate(`/dashboard/news-studio?bulletin=${data.bulletin_id}`);
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Could not hand off to News Studio");
  }
}
